import type { FC } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "../common/form/useForm";
import { Modal, useModal } from "../common/modal/Modal";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import { Button } from "../components/Button";
import { useWordpressActions } from "./useIntegrations";

interface ModalConnectWordpressProps {
	initialWebsite?: string;
}

export const ModalConnectWordpress: FC<ModalConnectWordpressProps> = ({
	initialWebsite,
}) => {
	const { connect: wpConnect } = useWordpressActions();
	const { close } = useModal();

	const form = useForm({
		initialValues: {
			website: initialWebsite ?? "",
		},
		onSubmit: async (values) => {
			await wpConnect.mutateAsync(values.website);
			close();
		},
	});

	return (
		<Modal size="lg">
			<h2>Connect Wordpress</h2>

			<Form onSubmit={form.handleSubmit}>
				<ExtraForm.Group label="Your Website URL" required>
					<ExtraForm.Control
						placeholder="https://yourwebsite.com"
						data-testid="website-url"
						{...form.getFieldState("website")}
						{...form.getFieldProps("website")}
					/>
				</ExtraForm.Group>

				<Button
					full
					variant="primary"
					loading={wpConnect.isPending}
					type="submit"
				>
					Connect
				</Button>
			</Form>
		</Modal>
	);
};
